import { useEffect, useRef, useSyncExternalStore } from "react"

const subscribe = (callback: () => void) => {
  document.addEventListener("visibilitychange", callback)
  return () => document.removeEventListener("visibilitychange", callback)
}

const getSnapshot = () => document.visibilityState === "visible"

const getServerSnapshot = () => true

type UseTabVisibilityOptions = {
  onVisible?: () => void
  onHidden?: () => void
}

export const useTabVisibility = (options?: UseTabVisibilityOptions) => {
  const isVisible = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  )
  const prevVisibleRef = useRef(isVisible)

  useEffect(() => {
    const wasHidden = !prevVisibleRef.current

    if (isVisible && wasHidden) {
      options?.onVisible?.()
    } else if (!isVisible && prevVisibleRef.current) {
      options?.onHidden?.()
    }

    prevVisibleRef.current = isVisible
  }, [isVisible, options])

  return isVisible
}

export default useTabVisibility
